import * as React from 'react'
import styled from 'styled-components'

import * as S from '../styles'
import type { WrapperProps } from '../styles/clickableTag'

export type ClickableTagProps = { label: React.ReactNode } & WrapperProps & React.ComponentPropsWithoutRef<'button'>

function ClickableTagComponent({
  label,
  isActive = false,
  ...props
}: ClickableTagProps): React.ReactElement<ClickableTagProps> {
  return (
    <S.clickableTag.Wrapper isActive={isActive} {...props}>
      {label}
    </S.clickableTag.Wrapper>
  )
}

export const ClickableTag = styled(ClickableTagComponent)<ClickableTagProps>``
ClickableTag.displayName = 'ClickableTag'
